import { useTranslation } from 'react-i18next';
import { NextGame } from '../components/schedule/NextGame';
import { PageWrapper } from '../components/layout/PageWrapper';
import { OrnamentDivider } from '../components/ui/OrnamentDivider';
import { useNextGameAvailability } from '../hooks/useReservation';
import { Seo } from '../components/Seo';

export function SchedulePage() {
  const { t } = useTranslation('schedule');
  const { data: availability } = useNextGameAvailability();

  return (
    <PageWrapper>
      <Seo title="Расписание игр" description="Расписание игр клуба спортивной мафии — каждую субботу в Banyo Library, Брисбен." path="/schedule" />
      <div className="text-center mb-12">
        <p className="font-mono text-xs text-mafia-gold tracking-[0.3em] uppercase mb-3">◆ Каждую субботу ◆</p>
        <h1 className="font-display text-5xl font-bold text-mafia-paper">{t('title')}</h1>
        <OrnamentDivider className="mt-8 max-w-xs mx-auto" />
      </div>

      <div className="grid md:grid-cols-2 gap-8 mb-10">
        <NextGame />

        <div className="card-vintage p-6">
          <p className="font-mono text-xs text-mafia-gold tracking-[0.2em] uppercase mb-4">◆ Расписание</p>
          <h2 className="font-display text-xl font-semibold text-mafia-paper mb-5">{t('recurring.title')}</h2>

          <div className="space-y-5">
            <div className="flex items-start gap-4">
              <span className="text-2xl">📅</span>
              <div>
                <p className="text-mafia-paper font-medium">{t('recurring.day')}</p>
                <p className="text-mafia-paper-dim text-sm mt-0.5">{t('recurring.desc')}</p>
              </div>
            </div>
            <div className="flex items-start gap-4">
              <span className="text-2xl">🕕</span>
              <div>
                <p className="text-mafia-paper font-medium">18:00</p>
                <p className="text-mafia-paper-dim text-sm mt-0.5">{t('recurring.time')}</p>
              </div>
            </div>
            <div className="flex items-start gap-4">
              <span className="text-2xl">📍</span>
              <div>
                <p className="text-mafia-paper font-medium">Banyo Library</p>
                <p className="text-mafia-paper-dim text-sm mt-0.5">284 St Vincents Rd, Banyo QLD 4014</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Player list */}
      {availability && availability.players.length > 0 && (
        <div className="card-vintage p-6 mb-10">
          <p className="font-mono text-xs text-mafia-gold tracking-[0.2em] uppercase mb-4">
            ◆ Записались на игру — {availability.confirmedCount} / {availability.totalSpots}
          </p>
          <div className="flex flex-wrap gap-2">
            {availability.players.map((name, i) => (
              <span
                key={i}
                className="font-mono text-xs text-mafia-paper-dim border border-mafia-border px-3 py-1"
              >
                {name}
              </span>
            ))}
          </div>
        </div>
      )}

      {/* Google Maps */}
      <div className="overflow-hidden border border-mafia-border">
        <iframe
          title="Banyo Library"
          src="https://maps.google.com/maps?q=284+St+Vincents+Rd,+Banyo+QLD+4014,+Australia&z=16&output=embed"
          width="100%"
          height="380"
          style={{ border: 0, filter: 'invert(0.9) hue-rotate(180deg)' }}
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />
      </div>
    </PageWrapper>
  );
}
